import React from "react";

const CheckboxButton = ({ fontSize = "sm", name, label, isShowingLabel = true, value, onChange, disabled, customStyle, iconSize, tabindex=undefined, readOnly = false }: any) => {
  return (
    <div className="flex">
      <input
          className="appearance-none m-0 p-0 hidden"
          type="checkbox"
          id={label + name}
          name={name}
          tabindex={tabindex}
        />
      <div className={`w-fit ${
        label ? "p-1" : ""
      } rounded relative flex items-center gap-2 ${
          !disabled && !readOnly
            ? "hover:cursor-pointer md:hover:bg-[#FFF3E5]"
            : "hover:cursor-default"
        } ${customStyle}`}
        onClick={() => !disabled && onChange()}
      >
        <div
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onChange?.();
          }}
          className="flex items-center justify-center self-start"
        >
          {value === true ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={` ${iconSize ? iconSize : "24"} `}
              height={` ${iconSize ? iconSize : "24"} `}
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_8574_236)">
                <path
                  d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                  fill={!disabled && !readOnly ? "#FF861A" : readOnly ? "#343A3D" : "#BBB"}
                />
              </g>
              <defs>
                <clipPath id="clip0_8574_236">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={` ${iconSize ? iconSize : "24"} `}
              height={` ${iconSize ? iconSize : "24"} `}
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_8574_230)">
                <path
                  d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
                  fill={!disabled && !readOnly ? "#808080" : readOnly ? "#343A3D" : "#BBB"}
                />
              </g>
              <defs>
                <clipPath id="clip0_8574_230">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}
        </div>
        {label && isShowingLabel && (
          <label
            className={`${
              fontSize === "sm" ? "text-sm" : "text-base"
            } leading-[1.3125rem] text-normal md:whitespace-nowrap ${
              !disabled ? "alu-text-base-2 hover:cursor-pointer" : "text-[#BBB]"
            } ${readOnly ? "hover:!cursor-default" : ""}`}
          >
            {label}
          </label>
        )}
      </div>
    </div>
  );
};

export default CheckboxButton;